

export class VehicleDetailsDocumentOutput implements IVehicleDetailsDocumentOutput {
    /** The auto-generated id of the tbl vehicle details document master */
    vehicle_details_document_id!: number;
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the document type master */
    document_type_id!: number;
    /** The document type name with 50 character limit */
    document_type_name!: string;
    /** The document  name with 50 character limit */
    document_name!: string;
    /** The document file with 2048 character limit */
    document_file!: string;
    /** The issue date  with 10 character limit */
    issue_date!: string;
    /** The expiry date  with 10 character limit */
    expiry_date!: string;
    /** Manage status of vehicle details document. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated creating time of tbl_vehicle_details_document item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_vehicle_details_document item add or update */
    updating_date!: any;

    constructor(data?: IVehicleDetailsDocumentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_document_id = _data["vehicle_details_document_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.document_type_id = _data["document_type_id"];
            this.document_type_name = _data["document_type_name"];
            this.document_name = _data["document_name"];
            this.document_file = _data["document_file"];
            this.issue_date = _data["issue_date"];
            this.expiry_date = _data["expiry_date"];
            this.status = _data["status"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
        }
    }

    static fromJS(data: any): VehicleDetailsDocumentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsDocumentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_document_id"] = this.vehicle_details_document_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["document_type_id"] = this.document_type_id;
        data["document_type_name"] = this.document_type_name;
        data["document_name"] = this.document_name;
        data["document_file"] = this.document_file;
        data["issue_date"] = this.issue_date;
        data["expiry_date"] = this.expiry_date;
        data["status"] = this.status;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        return data; 
    }
}

export interface IVehicleDetailsDocumentOutput {
    /** The auto-generated id of the tbl vehicle details document master */
    vehicle_details_document_id: number;
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the document type master */
    document_type_id: number;
    /** The document type name with 50 character limit */
    document_type_name: string;
    /** The document  name with 50 character limit */
    document_name: string;
    /** The document file with 2048 character limit */
    document_file: string;
    /** The issue date  with 10 character limit */
    issue_date: string;
    /** The expiry date  with 10 character limit */
    expiry_date: string;
    /** Manage status of vehicle details document. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated creating time of tbl_vehicle_details_document item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_vehicle_details_document item add or update */
    updating_date: any;
}

